<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Home</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container style="height: 400px; border: 1px solid #eee">
      <el-aside width="300px" style="background-color: #fff;">
        <router-link to="/machine/Machine">
          <h3>Machine Information</h3>
        </router-link>
        <Kanban :key="2" :list="workingList" :group="group" class="kanban working" header-text="Working" />
        <router-link to="/system/user">
          <h3>Account Information</h3>
        </router-link>
        <el-table :data="userData" stripe style="width: 100%">
          <el-table-column align="center" prop="account" label="Account" width="150"></el-table-column>
          <el-table-column align="center" prop="belonging" label="Beauty center" width="150"> </el-table-column>
        </el-table>
      </el-aside>
      <el-main style="padding: 10px;">
        <Map></Map>
      </el-main>
      <el-aside width="300px" style="background-color: #fff;">
        <router-link to="/alarm/Alarm">
          <h3>Alarm Information</h3>
        </router-link>
        <Kanban :key="3" :list="alarmList" :group="group" class="kanban alarm" header-text="Alarm" />
        <router-link to="/patient/Patient">
          <h3>User Information</h3>
        </router-link>
        <el-table :data="patientData" stripe style="width: 100%">
          <el-table-column align="center" prop="firstName" label="First Name" width="100"></el-table-column>
          <el-table-column align="center" prop="lastName" label="Last Name" width="100"></el-table-column>
          <el-table-column align="center" prop="belonging" label="Beauty center" width="100"> </el-table-column>
        </el-table>
      </el-aside>
    </el-container>
    <el-footer style='height: 22.5rem;'>
      <chart height="100%" width="100%" />
    </el-footer>
  </div>
</template>

<script>
import { getUserData, getPatientData, getMachineData, getAlarmData } from '../../api/userMG'
import Map from '@/components/Map'
import Chart from '@/components/Charts/MixChart'
import Kanban from '@/components/Kanban'
export default {
  data() {
    return {
      loginUser: JSON.parse(localStorage.getItem('userdata'))._source.authority,
      group: 'mission',
      patientData: [],
      userData: [],
      workingList: [],
      alarmList: [],
      patientFormInline: {
        page: 1,
        firstName: '',
        lastName: '',
        tel: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        creationTime: '',
        lastTreatmentTime: ''
      },
      userFormInline: {
        page: 1,
        account: '',
        firstName: '',
        lastName: '',
        tel: '',
        status: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        authority: '',
        editTime: ''
      },
      machineFormInline: {
        page: 1,
        serialNumber: '',
        machineName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        assignBelongingText: '',
        status: '',
        version: '',
        rentalTime: '',
        creationTime: '',
        lastOnlineTime: ''
      },
      alarmFormInline: {
        page: 1,
        serialNumber: '',
        machineName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        errorMsg: '',
        status: '',
        creationTime: ''
      }
    }
  },
  // 注册组件
  components: {
    Map,Chart,Kanban
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    if(this.loginUser !== 'Super administrator'){
      this.machineFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.alarmFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.userFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.patientFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
    }
    this.getmachineList(this.machineFormInline);
    this.getalarmList(this.alarmFormInline);
    this.getuserList(this.userFormInline);
    this.getpatientList(this.patientFormInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getmachineList(parameter){
      // 请求数据列表
      getMachineData(parameter)
        .then(res => {
          if (res.code === 201) {
            this.workingList = res.data;
            console.log(res.data);
          } else {
            // 分页赋值
            // this.pageparm.page = this.formInline.page;
            // this.pageparm.size = this.formInline.limit;
            // this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.$message.error('Menu failed to load, please try again laters！')
        })
    },
    getalarmList(parameter){
      // 请求数据列表
      getAlarmData(parameter)
        .then(res => {
          if (res.code === 201) {
            this.alarmList = res.data;
            console.log(res.data);
            // this.pageparm.page = res.page;
            // this.pageparm.total = res.total;
          } else {
            // 分页赋值
            // this.pageparm.page = this.formInline.page;
            // this.pageparm.size = this.formInline.limit;
            // this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.$message.error('Menu failed to load, please try again laters！')
        })
    },
    getuserList(parameter){
      // 请求数据列表
      getUserData(parameter)
        .then(res => {
          if (res.code === 201) {
            this.userData = res.data;
            // this.pageparm.page = res.page;
            // this.pageparm.total = res.total;
          } else {
            // 分页赋值
            // this.pageparm.page = this.formInline.page;
            // this.pageparm.size = this.formInline.limit;
            // this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.$message.error('Menu failed to load, please try again laters！')
        })
    },
    getpatientList(parameter){
      // 请求数据列表
      getPatientData(parameter)
        .then(res => {
          if (res.code === 201) {
            this.patientData = res.data;
            // this.pageparm.page = res.page;
            // this.pageparm.total = res.total;
          } else {
            // 分页赋值
            // this.pageparm.page = this.formInline.page;
            // this.pageparm.size = this.formInline.limit;
            // this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.$message.error('Menu failed to load, please try again laters！')
        })
    }


  }
}
</script>

<style lang="scss" scoped>
h3{
  margin: 10px 0;
  font-size: 18px;
  padding-left: 6px;
  text-align: left;
  color: #751358;
}
.el-header, .el-footer {
  text-align: center;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 160px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}


</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue